import React from 'react';
import { Dialog, DialogTitle, DialogContent, Button, Typography } from '@material-ui/core';

const ScriptDialog = ({ open, onClose, scriptContent }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>
                <div className="flex items-center justify-between">
                    <Typography variant="h6">Script Content</Typography>
                    <Button
                        className="whitespace-no-wrap ml-2"
                        id="close-btn"
                        variant="contained"
                        onClick={onClose}
                    >
                        Close
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <Typography style={{ whiteSpace: 'pre-wrap' }}>
                    {scriptContent ? scriptContent : 'No Script Available'}
                </Typography>
            </DialogContent>
        </Dialog>
    );
};

export default ScriptDialog;
